/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import {
  screenMdMin,
  screenSmMin,
  black,
  white,
} from '@spotify-internal/encore-web-v5';
import { iconExternalLink } from '../../../styles/mixins';
import {
  fontWeightBook,
  fontWeightBold,
  gridGutterWidth,
  navbarHeight,
} from '../../../styles/variables';

export const Hero = styled.div`
  background-color: ${black};
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 100%;

  margin-bottom: 40px;
  padding: 88px 15px 45px 0;

  @media (min-width: ${screenSmMin}) {
    margin-bottom: 64px;
  }

  @media (min-width: ${screenMdMin}) {
    padding: ${parseInt(navbarHeight, 10) + 70}px 0 130px;
  }

  &.frodor-nav {
    @media (min-width: ${screenMdMin}) {
      padding: ${parseInt(navbarHeight, 10) + 70}px 0 130px;
    }
  }

  [class*='col'] {
    position: static;
  }

  h1 {
    margin: 0 !important;
    padding: 0;

    a {
      color: inherit;
    }
  }

  .hero-artist-info {
    bottom: -116px;
    position: absolute;
    right: ${parseInt(gridGutterWidth, 10) / 2}px;

    a:hover {
      color: ${white};
    }

    h2,
    p {
      color: ${white};
      letter-spacing: 0.03em;
      text-align: right;
    }

    h2 {
      margin-right: -1.25em;
      font-weight: ${fontWeightBold};
      font-size: 24px;
      line-height: 0.9;
    }

    p {
      margin-top: 5px;
      font-weight: ${fontWeightBook};
      letter-spacing: 0.03em;
      line-height: 1.66;
    }

    .external {
      color: ${white};
      text-transform: none;

      &::after {
        ${iconExternalLink(white)};
      }
    }
  }

  .container {
    position: relative;
    z-index: 2; /* make sure text is in front of .main:before shadow */
  }
`;
